"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItem = exports.updateItemQuantity = exports.addOrIncrementItem = exports.DEFAULT_INCREMENT_CART_QUANTITY = exports.formatQuantityLabel = exports.getTotalBRLPriceByCart = exports.getTotalPriceByCart = exports.getTotalItemsByCart = exports.saveOrderDataToLocalStorage = exports.getCartFromLocalStorage = exports.removeCartFromLocalStorage = exports.saveCartToLocalStorage = exports.removeCartItemsToLocalStorage = exports.saveCartItemsToLocalStorage = exports.getCartItemsFromLocalStorage = exports.CART_DATA_LOCAL_STORAGE_KEY = exports.CART_ITEMS_LOCAL_STORAGE_KEY = void 0;
const parseToBRL_1 = require("../../utils/helpers/parseToBRL");
exports.CART_ITEMS_LOCAL_STORAGE_KEY = 'order_list';
exports.CART_DATA_LOCAL_STORAGE_KEY = 'CART_ID';
const getCartItemsFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem(exports.CART_ITEMS_LOCAL_STORAGE_KEY) || '[]');
};
exports.getCartItemsFromLocalStorage = getCartItemsFromLocalStorage;
const saveCartItemsToLocalStorage = (items) => {
    localStorage.setItem(exports.CART_ITEMS_LOCAL_STORAGE_KEY, JSON.stringify(items));
};
exports.saveCartItemsToLocalStorage = saveCartItemsToLocalStorage;
const removeCartItemsToLocalStorage = () => {
    localStorage.removeItem(exports.CART_ITEMS_LOCAL_STORAGE_KEY);
};
exports.removeCartItemsToLocalStorage = removeCartItemsToLocalStorage;
const saveCartToLocalStorage = (cart) => {
    localStorage.setItem(exports.CART_DATA_LOCAL_STORAGE_KEY, JSON.stringify(cart));
};
exports.saveCartToLocalStorage = saveCartToLocalStorage;
const removeCartFromLocalStorage = () => {
    localStorage.removeItem(exports.CART_DATA_LOCAL_STORAGE_KEY);
};
exports.removeCartFromLocalStorage = removeCartFromLocalStorage;
const getCartFromLocalStorage = () => {
    try {
        return JSON.parse(localStorage.getItem(exports.CART_DATA_LOCAL_STORAGE_KEY));
    }
    catch (_a) {
        return null;
    }
};
exports.getCartFromLocalStorage = getCartFromLocalStorage;
const saveOrderDataToLocalStorage = (order) => {
    localStorage.setItem(`${order.orderBackofficeId}_share`, JSON.stringify(Object.assign(Object.assign({}, order), { createdAt: new Date().toISOString() })));
};
exports.saveOrderDataToLocalStorage = saveOrderDataToLocalStorage;
const getTotalItemsByCart = (cartItems) => cartItems.reduce((acc, cur) => acc + cur.quantity, 0);
exports.getTotalItemsByCart = getTotalItemsByCart;
const getTotalPriceByCart = (cartItems) => cartItems.reduce((acc, cur) => acc + parseFloat(cur.discountPrice) * cur.quantity, 0);
exports.getTotalPriceByCart = getTotalPriceByCart;
const getTotalBRLPriceByCart = (cartItems) => (0, parseToBRL_1.parseToBRL)((0, exports.getTotalPriceByCart)(cartItems));
exports.getTotalBRLPriceByCart = getTotalBRLPriceByCart;
const formatQuantityLabel = (quantity) => String(quantity).padStart(2, '0');
exports.formatQuantityLabel = formatQuantityLabel;
exports.DEFAULT_INCREMENT_CART_QUANTITY = 1;
const addOrIncrementItem = (cart, item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);
    if (existingItem) {
        return cart.map((cartItem) => cartItem.id === item.id
            ? Object.assign(Object.assign({}, cartItem), { quantity: cartItem.quantity + exports.DEFAULT_INCREMENT_CART_QUANTITY }) : cartItem);
    }
    return [Object.assign(Object.assign({}, item), { quantity: exports.DEFAULT_INCREMENT_CART_QUANTITY }), ...cart];
};
exports.addOrIncrementItem = addOrIncrementItem;
const updateItemQuantity = (cart, item) => {
    return cart.map((cartItem) => cartItem.id === item.id ? Object.assign(Object.assign({}, cartItem), { quantity: item.quantity }) : cartItem);
};
exports.updateItemQuantity = updateItemQuantity;
const removeItem = (cart, itemId) => {
    return cart.filter((cartItem) => cartItem.id !== itemId);
};
exports.removeItem = removeItem;
